import React, { useEffect, useRef, useState } from "react";
import { Table, Tooltip, Col, Input, Row, Image, Switch, Tag, Button } from "antd";
import HeadingBack from "./common/HeadingBack";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import SvgIcon from "./const/SvgIcon";
import { allApiAction } from "../Redux/common/action";

import { ExclamationCircleFilled } from "@ant-design/icons";
import { Modal } from "antd";
import { toast } from "react-toastify";
import { URL } from "../Redux/common/url";
import { AsyncPaginate } from "react-select-async-paginate";
import moment from "moment";
import LoadOptions from "./common/LoadOptions";

import { CKEditor } from "ckeditor4-react";

const defaultObj = {
  occasion_id: "",
  function_id: "",
  name: "",
  description: "",
  image: "",
  addOn: false,
};

function FunctionEssentials() {
  const { confirm } = Modal;
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const [essentialDetails, setEssentialDetails] = useState({ ...defaultObj });
  const [filterData, setFilterData] = useState({ occasion: "", func: "" });

  const { essentialList } = useSelector((state) => ({
    essentialList: state?.allApi?.essential_list || {},
  }));
  const listData = essentialList?.data ? essentialList?.data : [];

  useEffect(() => {
    fetchData();
  }, [search, page, filterData]);

  const fetchData = () => {
    const { occasion, func } = filterData;
    dispatch(allApiAction.getEssentials({
      page: page,
      search: search,
      occasion_id: occasion ? occasion?.value : "",
      function_id: func ? func?.value : ""
    }));
  };

  const columns = [
    // ... (all columns remain exactly the same)
    {
      width: "10%",
      key: "image",
      title: "Image",
      dataIndex: "image",
      render: (value, item, index) => {
        return (
          <>
            <div style={{ width: "50px" }}>
              <Image src={URL?.API_BASE_URL + item?.image} alt="N/A" />
            </div>
          </>
        );
      },
    },
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "Occasion", dataIndex: "occasion", key: "occasion", render: (value) => value.title },
    { title: "Function", dataIndex: "function", key: "function", render: (value) => value.name },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text) => (
        <div dangerouslySetInnerHTML={{ __html: text }} style={{ wordBreak: "break-word" }} />
      ),
    },
    {
      title: "Add On",
      dataIndex: "addOn",
      key: "addOn",
      render: (value) => value ? <Tag color="green">Yes</Tag> : <Tag color="red">No</Tag>
    },
    { title: "Created Date", dataIndex: "created_at", key: "created_at", render: (value) => moment(value).format("DD-MM-YYYY") },
    {
      title: "Actions",
      key: "action",
      className: "table_action_col",
      render: (value, item) => {
        return (
          <>
            <Tooltip title="Edit">
              <span
                className="cursor-pointer"
                onClick={() => {
                  handleModal({
                    ...item,
                    addOn: item.addOn ? true : false,
                    occasion_id: { value: item?.occasion?.id, label: item?.occasion?.title },
                    function_id: { value: item?.function?.id, label: item?.function?.name },
                  });
                }}
              >
                <SvgIcon.Edit className="scale-icon edit-icon" />
              </span>
            </Tooltip>
            <Tooltip title="Delete">
              <span className="cursor-pointer" onClick={() => showDeleteConfirm(item?.id)}>
                <SvgIcon.deletebtn className="scale-icon edit-icon" />
              </span>
            </Tooltip>
          </>
        );
      },
    },
  ];

  const handleDelete = async (id) => {
    await dispatch(allApiAction.deleteEssential({ id, page }));
    dispatch(allApiAction.getEssentials({ page: 1 }));
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) setSelectedFile(event.target.files);
  };

  const handleTextChange = (e) => {
    const { name, value } = e.target;
    if (name === "occasion_id") {
      setEssentialDetails((prev) => ({ ...prev, occasion_id: value, function_id: "" }));
    } else {
      setEssentialDetails((prev) => ({ ...prev, [name]: value }));
    }
  };

  const showDeleteConfirm = (id) => {
    confirm({
      title: "Are you sure delete this Essential?",
      icon: <ExclamationCircleFilled />,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        handleDelete(id);
      },
    });
  };

  const handleModal = (editData) => {
    if (editData && editData !== undefined) {
      setEssentialDetails(editData);
    } else {
      setEssentialDetails({ ...defaultObj });
      setSelectedFile(null);
    }
    setIsModalOpen(!isModalOpen);
  };

  const handleSearch = (e) => setSearch(e);
  const handlePageChange = (currentPage) => setPage(currentPage);

  const checkValidation = () => {
    if (!essentialDetails?.occasion_id) {
      toast.error("Please select Occasion");
      return false;
    }
    if (!essentialDetails?.function_id) {
      toast.error("Please select Function");
      return false;
    }
    if (!essentialDetails?.name) {
      toast.error("Please enter a name");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!checkValidation()) return;

    const data = new FormData();
    data.append("occasion_id", essentialDetails?.occasion_id?.value);
    data.append("function_id", essentialDetails?.function_id?.value);
    data.append("name", essentialDetails?.name);
    data.append("addOn", essentialDetails?.addOn ? 1 : 0);

    if (essentialDetails?.description) {
      data.append("description", essentialDetails?.description);
    }

    if (selectedFile) {
      for (let i = 0; i < selectedFile.length; i++) {
        data.append("image", selectedFile[i]);
      }
    }

    try {
      if (essentialDetails?.id) {
        data.append("id", essentialDetails?.id);
        await dispatch(allApiAction.updateEssential(data));
      } else {
        await dispatch(allApiAction.addEssential(data));
      }
      setSelectedFile(null);
      dispatch(allApiAction.getEssentials({ page: 1 }));
      handleModal();
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div>
      {/* Header Bar */}
      <div className="flex">
        <div>
          <HeadingBack title={"Essential"} subHeading={`Total ${essentialList?.total || 0} Essential`} />
        </div>
        <Col md={5} sm={5} lg={3} xs={6} className="ml-5 pl-5">
          <Input
            type="text"
            autoComplete="new-off"
            className="form-control"
            onChange={(e) => handleSearch(e.target.value)}
            placeholder="Search..."
            value={search}
          />
        </Col>
        <Col md={4} sm={4} lg={4} xs={6} className="ml-5">
          <AsyncPaginate
            additional={{ page: 1, value: "id", label: "title" }}
            className="p-0"
            placeholder="Occasion"
            value={filterData?.occasion}
            loadOptions={(search, loaded, additional) => LoadOptions(URL.get_occasions, search, loaded, additional)}
            onChange={(value) => setFilterData((prev) => ({ ...prev, occasion: value, func: "" }))}
          />
        </Col>
        <Col md={4} sm={4} lg={4} xs={6} className="ml-5">
          <AsyncPaginate
            key={filterData?.occasion?.value || "default"}
            additional={{
              page: 1,
              value: "id",
              label: "name",
              extras: { occasion_id: filterData?.occasion?.value || "" }
            }}
            className="p-0"
            placeholder="Function"
            value={filterData?.func}
            loadOptions={(search, loaded, additional) => LoadOptions(URL.get_functions, search, loaded, additional)}
            onChange={(value) => setFilterData((prev) => ({ ...prev, func: value }))}
          />
        </Col>
        <Col md={4} sm={4} xs={12} className="ml-5">
          <Button
            onClick={() => {
              setFilterData({ occasion: "", func: "" });
              setSearch("");
            }}
            disabled={!filterData?.occasion && !filterData?.func}
          >
            Reset
          </Button>
        </Col>
        <div className="flex flex1 align-items-center justify-content-end">
          <Tooltip title="Add">
            <span className="jop_btn" onClick={() => handleModal()}>
              Add
              <SvgIcon.Add width={40} height={40} className="cursor-pointer" />
            </span>
          </Tooltip>
        </div>
      </div>

      {/* Pagination Table */}
      <div className="tableResponsive mt-10">
        <Table
          dataSource={listData}
          columns={columns}
          className={"table antd_table"}
          pagination={{
            current: page,
            pageSize: 10,
            onChange(currentPage, pageSize) {
              handlePageChange(currentPage);
            },
            hideOnSinglePage: true,
            total: essentialList?.total ? essentialList?.total : 0,
          }}
        />
      </div>

      {/* Form Modal */}
      <Modal
        title="Essential Modal"
        open={isModalOpen}
        onOk={handleSubmit}
        onCancel={() => setIsModalOpen(false)}
      >
        <Row gutter={[20, 20]}>
          {/* Occasion Dropdown */}
          <Col lg={12} md={12} sm={12} xs={12}>
            <label className="mb-2">Select Occasion :</label>
            <AsyncPaginate
              additional={{ page: 1, value: "id", label: "title" }}
              value={essentialDetails?.occasion_id}
              loadOptions={(search, loaded, additional) => LoadOptions(URL.get_occasions, search, loaded, additional)}
              onChange={(value) => handleTextChange({ target: { name: "occasion_id", value } })}
            />
          </Col>

          {/* Function Dropdown - Cascading */}
          <Col lg={12} md={12} sm={12} xs={12}>
            <label className="mb-2">Select Function :</label>
            <AsyncPaginate
              key={essentialDetails?.occasion_id?.value || "default-occasion"}
              additional={{
                page: 1,
                value: "id",
                label: "name",
                extras: { occasion_id: essentialDetails?.occasion_id?.value || "" }
              }}
              value={essentialDetails?.function_id}
              loadOptions={(search, loaded, additional) => LoadOptions(URL.get_functions, search, loaded, additional)}
              onChange={(value) => handleTextChange({ target: { name: "function_id", value } })}
            />
          </Col>

          <Col lg={12} md={12} sm={12} xs={12}>
            <label className="mb-2">Name :</label>
            <input
              autoComplete="off"
              className="form-control"
              placeholder="Enter Name"
              name="name"
              value={essentialDetails?.name || ""}
              onChange={handleTextChange}
            />
          </Col>

          <Col lg={12} md={12} sm={12} xs={12}>
            <label className="mb-2">Image :</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
            />
          </Col>

          <Col lg={24} md={24} sm={24} xs={24} className="mt-10">
            <div className="mb-4">
              <label className="form-label">Description</label>
              <div className="quill-container" style={{ marginBottom: '50px' }}>
                <CKEditor
                  initData={essentialDetails?.description || ""}
                  config={{
                    extraPlugins: 'table',
                    removePlugins: 'elementspath',
                    resize_enabled: false,
                    toolbarGroups: [
                      { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
                      { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align'] },
                      { name: 'insert' },
                      { name: 'styles' },
                      { name: 'colors' },
                      { name: 'links' },
                      { name: 'table' }
                    ],
                    // Optional: Configure table plugin defaults or allowed features
                    table_removeTableTag: false
                  }}
                  onChange={(event) => {
                    const data = event.editor.getData();
                    setEssentialDetails((prev) => ({ ...prev, description: data }));
                  }}
                />
              </div>
            </div>
          </Col>

          <Col lg={12} md={12} sm={12} xs={12}>
            <label className="mb-2">Add On :</label>
            <Switch
              checked={essentialDetails?.addOn}
              onChange={(checked) => handleTextChange({ target: { name: "addOn", value: checked } })}
            />
          </Col>
        </Row>
      </Modal>
    </div>
  );
}

export default FunctionEssentials;